import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  QuoteContentTemplateRequest,
  QuoteContentTemplateResponse,
  GenerateQuoteFromTemplateRequest
} from '../models/quote-content-template.model';
import { QuoteResponse } from '../models/quote.model';

@Injectable({
  providedIn: 'root'
})
export class QuoteContentTemplateApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/quote-content-templates?businessId=1 - List active content templates (requires Manager+)
  getAllTemplates(businessId: number): Observable<QuoteContentTemplateResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<QuoteContentTemplateResponse[]>(`${this.apiUrl}/quote-content-templates`, { params });
  }

  // GET /api/quote-content-templates/{id}?businessId=1 - Get content template (with items)
  getTemplateById(id: number, businessId: number): Observable<QuoteContentTemplateResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<QuoteContentTemplateResponse>(`${this.apiUrl}/quote-content-templates/${id}`, { params });
  }

  // POST /api/quote-content-templates?businessId=1 - Create content template (requires Manager+)
  createTemplate(businessId: number, template: QuoteContentTemplateRequest): Observable<QuoteContentTemplateResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<QuoteContentTemplateResponse>(`${this.apiUrl}/quote-content-templates`, template, { params });
  }

  // PUT /api/quote-content-templates/{id}?businessId=1 - Update template (replaces items) (requires Manager+)
  updateTemplate(id: number, businessId: number, template: QuoteContentTemplateRequest): Observable<QuoteContentTemplateResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<QuoteContentTemplateResponse>(`${this.apiUrl}/quote-content-templates/${id}`, template, { params });
  }

  // DELETE /api/quote-content-templates/{id}?businessId=1 - Delete template (requires Admin+)
  deleteTemplate(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/quote-content-templates/${id}`, { params });
  }

  // POST /api/quote-content-templates/{id}/generate-quote - Generate a draft quote from the template
  // businessId travels in the request body (GenerateQuoteFromTemplateRequest), not as query param.
  generateQuote(id: number, request: GenerateQuoteFromTemplateRequest): Observable<QuoteResponse> {
    return this.http.post<QuoteResponse>(`${this.apiUrl}/quote-content-templates/${id}/generate-quote`, request);
  }
}
